import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CategoryAccountRequest, EditCategoryVendorRequest, VendorResponse } from '../models/vendor.model';
import { CategoryResponse, CategoryVendorResponse } from '../models/category.model';

@Injectable({
  providedIn: 'root'
})
export class VendorService {
  private URL = environment.api;
  constructor(
    private http: HttpClient
  ) { }

  getVendors() {
    return this.http.get(this.URL + 'api/erp/inventory/vendor');
  }

  delete(updatedVendor: VendorResponse) {
    return this.http.delete(this.URL + "api/erp/inventory/vendor/" + updatedVendor.id);
  }

  getRegimes() {
    return this.http.get(this.URL + "api/erp/inventory/vendor/regimes");
  }

  getPriceLists() {
    return this.http.get(this.URL + "api/erp/inventory/product/price/lists");
  }

  getAllCategoriesVendor() {
    return this.http.get(this.URL + "api/erp/inventory/vendor/categories");
  }

  editCategoryVendor(edited: EditCategoryVendorRequest) {
    return this.http.put(this.URL + `api/erp/inventory/vendor/categories/single/${edited.id}`, edited);
  }

  createCategoryAccountVendor(created: CategoryAccountRequest) {
    return this.http.post(this.URL + `api/erp/inventory/vendor/categories/${created.accountId}`, created);
  }

  validateCategory(category: CategoryVendorResponse){
    return this.http.put(this.URL + `api/erp/inventory/vendor/categories/ /${category.id}`, null);
  }

  activateCategory(category: CategoryVendorResponse){
    return this.http.put(this.URL + `api/erp/inventory/vendor/categories/activate/${category.id}`, null);
  }

  deleteCategory(category: CategoryVendorResponse){
    return this.http.delete(this.URL + `api/erp/inventory/vendor/categories/single/${category.id}`);
  }

  //https://app.servicios.gt/api/erp/inventory/vendor/categories?category=Libros%20de%20Docencia
  createCategoryVendor(category: string) {
    return this.http.post(this.URL + "api/erp/inventory/vendor/categories", null, {
      params: {
        category: category
      }
    });
  }

  putVendor(updatedVendor: any) {
    return this.http.put(this.URL + "api/erp/inventory/vendor/" + updatedVendor.id, updatedVendor);
  }

  postVendor(updatedVendor: any) {
    return this.http.post(this.URL + "api/erp/inventory/vendor", updatedVendor);
  }

  getClientsByClue(clue: string) {
    return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing",
      {
        params: {
          clue: clue,
          client: true,
          provider: false
        }
      }
    );
  }

  getProvidesByClue(clue: string) {
    return this.http.get(this.URL + "api/erp/inventory/vendor/search/existing",
      {
        params: {
          clue: clue,
          client: false,
          provider: true
        }
      }
    );
  }

  getAllClientsFromDepartmentAndTown(department: number, kindPerson: number, limit: number, town: number, warehouse: number) {
    return this.http.get(this.URL + "api/erp/inventory/vendor/search/sat/all?" + `department=${department}&kindPerson=${kindPerson}&limit=${limit}&town=${town}&warehouse=${warehouse}`);
  }

  editDoc(vendorId: number, categoryId: number, updatedCategories: EditCategoryVendorRequest[]) {
    return this.http.post(this.URL + "api/erp/inventory/vendor/editDoc/" + vendorId + "/" + categoryId, updatedCategories);
  }

  getCategoriesVendor(idVendor: number) {
    return this.http.get(this.URL + "api/erp/inventory/vendor/categories/" + idVendor)
  }

  deleteExpense(expenseId: number, reason: string) {
    return this.http.post(this.URL + `api/erp/expense/deleteDocument/${expenseId}`, reason);
  }

  editCategoryVendorExpense(idVendor, idCategory) {
    return this.http.put(this.URL + `api/erp/inventory/vendor/categories/${idVendor}/${idCategory}`, null);
  }

  updateVendorBillingData(vendorId: number,request: any) {
    return this.http.put(this.URL + 'api/erp/inventory/vendor/update-billing-data/' + vendorId, request);
  }
}
